import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-max-activities",
  templateUrl: "./field-set-max-activities.component.html",
  styles: [],
})
export class FieldSetMaxActivitiesComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
